import { Mutation } from 'vuex';
import { IModuleState } from './types';
import { IZoneRecord } from '@/store/meta/zone/types';

// 开放世界列表
export const setOpenWorlds: Mutation<IModuleState> = (state, payload) => {
  state.openWorlds.data = payload.data;
  state.openWorlds.pageNum = payload.pageNum;
  state.openWorlds.pageSize = payload.pageSize;
  state.openWorlds.total = payload.total;
  state.openWorlds.loading = !!payload.loading;
};

// 开放世界详情
export const setOpenWorldDetail: Mutation<IModuleState> = (state, payload) => {
  state.worldDetail.data = payload.data;
  state.worldDetail.loading = !!payload.loading;
};

// 开放世界详情
export const setWorldSlotDetail: Mutation<IModuleState> = (state, payload) => {
  state.slotDetail.data = payload.data;
  state.slotDetail.loading = !!payload.loading;
};

// 副本列表
export const setWorldSlotZones: Mutation<IModuleState> = (state, payload) => {
  const list = (payload.data || []) as IZoneRecord[];
  state.zones.data = list.map((item) => ({
    id: item.id,
    optionValue: item.name,
    optionKey: item.fullpath,
    groupCode: '',
  }));
  state.zones.loading = !!payload.loading;
};

// 控制项列表
export const setZoneTriggers: Mutation<IModuleState> = (state, payload) => {
  state.triggers.data = payload.data;
  state.triggers.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
